/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AdditionalFundsRequiredPropertiesDto } from '@/api/backend/public/additional-funds/additional-funds-required-properties.dto';
import type { LoanDetails } from '@/types';
import type { AdditionalFundsRequiredProperty } from '@/types/AdditionalFundsRequiredProperty';
import { mapToApi } from '..';

export const additionalFunds = (data?: LoanDetails): any => ({
  hasAdditionalSavings: data ? data.savingsAmount > 0 : false,
  additionalSavingsAmount: 0, // data.savingsAmount,
  hasGiftedFunds: data ? data.giftedAmount > 0 : false,
  // The persisted columns the CRM scenario tool reads. The DTO's `giftedSavings*` names map to no
  // column, so the gifted amount was dropped on write.
  giftedFundsAmount: data?.giftedAmount ?? 0,
  giftedFundsPercentage:
    !data || data.savingsAmount === 0 ? 0 : Math.round((data.giftedAmount / data.savingsAmount) * 100),
});

export const additionalFundsRequiredProperties = (
  data: AdditionalFundsRequiredProperty,
): AdditionalFundsRequiredPropertiesDto => ({
  country: 'au',
  propertyType: data.propertyType,
  propertyPurpose: data.propertyPurpose,
  line1: data.addressLine ?? '',
  line2: data.addressLine2 ?? '',
  postCode: data.postcode ?? '',
  state: mapToApi.australianState(data.state),
  city: data.locality ?? '',
  contractForSale: data.isThereContractForSale ?? false,
  purchasePrice: data.purchasePrice ?? 0,
  depositAmount: data.depositAmount ?? 0,
  depositPaidType: data.depositType,
  stampDutyStatus: data.stampDutyStatus,
  transferFeeCovered: data.transferFeeCovered,
  settlementDate: data.settlementDate ?? '',
});
